<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Does your work contribute to Africa's Sustainable Development?</h2>
    <p>
      Asoko Insight and United Nations Development Programme (UNDP) have partnered to identify and publically recognise companies across Africa that contribute to the infrastructure, equality and all aspects that support the Sustainable Development Goals (SDG).
    </p>
    <div class="action-wrap">
      <a @click="openProposals" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Learn More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'undp-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openProposals() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'UNDP Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'UNDP Block',
      })
      this.$router.push('/deals/platforms/undp-africa-business-map')
    },
  },
}
</script>
